module.exports = __webpack_public_path__ + "static/media/10.Falicitation to Bhaskar Kamath.d2932832.jpg";